import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createNpaReportApi } from "./api";
import { CreateNpaReportRequest, NpaReportReduxTypes } from "./types";

function* createNpaReport({ payload }: CreateNpaReportRequest): SagaIterator {
    try {
        const response = yield call(createNpaReportApi, payload);
        yield put({
            type: NpaReportReduxTypes.NPA_REPORT_SUCCESS,
            payload: { data: response.data.data }
        })
    } catch (error: any) {
        yield put({
            type: NpaReportReduxTypes.NPA_REPORT_ERROR,
            payload:{ error: error }
    })
}
}

export function* watchCreateNpaReport(){
yield takeEvery(NpaReportReduxTypes.NPA_REPORT,createNpaReport)
}

function* npaReportSaga(){
    yield all([fork(watchCreateNpaReport)])
}

export default npaReportSaga;

